import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d9sr2ctlbrt1qcgaj8ig';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrorMsg('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setSubmitted(true);
      return;
    }

    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }

      if (res.ok && parsed?.code === 'OK') {
        setSubmitted(true);
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text || '提交失败，请稍后再试';
        setErrorMsg(msg);
      }
    } catch {
      setErrorMsg('网络错误，请检查网络后重试');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
          订阅我们的资讯
        </h2>
        <p className="mt-3 text-sm text-foreground-500">
          第一时间获取茄子视频最新动态、热门内容和创作技巧
        </p>

        {submitted ? (
          <div className="mt-6 p-4 rounded-lg bg-accent-100 text-accent-800 text-sm">
            <i className="ri-check-line mr-1 w-4 h-4 inline-flex items-center justify-center"></i>
            订阅成功！感谢您的关注，我们会定期为您推送精彩内容。
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="mt-6 flex flex-col sm:flex-row gap-3"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入您的邮箱地址"
              required
              className="flex-1 px-4 py-3 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400"
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="hp-field"
            />
            <button
              type="submit"
              className="bg-primary-500 text-white px-6 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              立即订阅
            </button>
          </form>
        )}

        {errorMsg && (
          <p className="mt-3 text-xs text-primary-600">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}